<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 虚拟电厂 </el-breadcrumb-item>
          <el-breadcrumb-item>邀约</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="toolbar-box">
        <div class="list-box">
          <div class="r-list">
            <el-date-picker
              style="width: 280px"
              v-model="dateRange"
              type="daterange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            >
            </el-date-picker>
          </div>
          <div class="search-box">
            <el-button
              type="primary"
              slot="append"
              icon="el-icon-search"
              @click="initData"
              style="float: right"
            ></el-button>
          </div>
          <div class="btn-box" v-show="false">
            <el-button-group>
              <el-button type="primary" @click="toggleToolsBar"></el-button>
            </el-button-group>
          </div>
        </div>
      </div>

      <div class="content-box">
        <el-card class="table-card">
          <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="listData"
            stripe
            class="table-list"
          >
            <el-table-column width="15"></el-table-column>
            <el-table-column label="id" align="center" min-width="80">
              <template slot-scope="scope">
                <h4>
                  {{ scope.row.id }}
                </h4>
              </template>
            </el-table-column>
            <el-table-column
              prop="creditCode"
              label="聚合商唯一标识"
              min-width="150"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="outInvitationId"
              label="外部（电厂）邀约计划id"
              min-width="180"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="exchangeType"
              label="交易品种"
              align="center"
              min-width="100"
            ></el-table-column>
            <el-table-column
              prop="inviteRange"
              label="缴约调节的用户编号"
              align="center"
              min-width="240"
            ></el-table-column>

            <el-table-column label="邀约时间" align="center" min-width="150">
              <template slot-scope="scope">
                <span class="nowrap">{{ scope.row.invitationTime }}</span>
              </template>
            </el-table-column>

            <el-table-column
              label="邀约回复截止时间"
              align="center"
              min-width="150"
            >
              <template slot-scope="scope">
                <span class="nowrap">{{ scope.row.replyEndTime }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="响应执行开始时间"
              align="center"
              min-width="150"
            >
              <template slot-scope="scope">
                <span class="nowrap">{{ scope.row.startTime }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="响应执行结束时间"
              style="text-align: center"
              min-width="150"
            >
              <template slot-scope="scope">
                <span class="nowrap">{{ scope.row.endTime }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="回复时间"
              style="text-align: center"
              min-width="150"
            >
              <template slot-scope="scope">
                <span class="nowrap">{{ scope.row.replyTime }}</span>
              </template>
            </el-table-column>
            <!-- 0不参加1参加 -->
            <el-table-column
              label="参不参加"
              style="text-align: center"
              min-width="90"
            >
              <template slot-scope="scope">
                <span
                  style="cursor: pointer"
                  class="nowrap"
                  v-if="scope.row.replyResult === 1"
                  @click="onJoin(scope.row.id)"
                  >参加</span
                >
                <span
                  style="cursor: pointer"
                  class="nowrap"
                  v-else-if="scope.row.replyResult === 0"
                  @click="onJoin(scope.row.id)"
                  >不参加</span
                >
                <span
                  style="cursor: pointer"
                  class="nowrap"
                  v-else
                  @click="onJoin(scope.row.id)"
                  >没有确定</span
                >
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              style="text-align: center"
              width="200"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  icon="el-icon-view"
                  @click="selectItem(scope.row.id)"
                  >查看</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  @click="deltem(scope.row.id)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-card>

        <div class="pager-box">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 弹出层 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible">
      <el-select @change="changJoin()" v-model="value" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveDict()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { AxiosAjax } from "../../../js/axios.config";

export default {
  data() {
    return {
      loading: false,
      dateRange: [],
      totalCount: 0,
      pageSize: 10,
      pageIndex: 1,
      listData: [],
      params: {
        startTime: "",
        endTime: "",
        page: 0,
        pageSize: 0,
      },
      options: [
        {
          value: 1,
          label: "参加",
        },
        {
          value: 0,
          label: "不参加",
        },
      ],
      value: "",
      id: 0,
      join: -1,
      dialogFormVisible: false,
      title: "是否参加邀约",
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      if (!this.dateRange) {
        this.params.startTime = "";
        this.params.endTime = "";
      } else if (this.dateRange.length != 0) {
        this.params.startTime = this.dateRange[0];
        this.params.endTime = this.dateRange[1];
      }
      const _this = this;
      AxiosAjax({
        url:
          "/v2/invitations?page=" +
          _this.pageIndex +
          "&&pageSize=" +
          _this.pageSize +
          "&&startTime=" +
          _this.params.startTime +
          "&&endTime=" +
          _this.params.endTime,
        success: function (res) {
          _this.totalCount = res.data.data.total;
          _this.listData = res.data.data.list;
        },
      });
    },

    selectItem(id) {
      this.$router.push({ name: "InvitationShow", query: { id: id } });
    },
    //修改参加邀约
    onJoin(id) {
      this.id = id;
      this.dialogFormVisible = true;
    },
    saveDict() {
      const _this = this;
      AxiosAjax({
        url: "/v2/invitation/reply",
        method: "put",
        data: { id: _this.id, replyResult: _this.join },
        success: function (res) {
          if (res.data.code == 200) {
            _this.$message({
              message: "修改成功",
              type: "success",
            });
            _this.dialogFormVisible = false;
            _this.initData();
            _this.value = "";
          }
        },
      });
    },
    changJoin() {
      this.join = this.value;
    },
    deltem(id) {
      const _this = this;
      AxiosAjax({
        url: "/v2/deleteInvitation/" + id,
        method: "delete",
        success: function (res) {
          if (res.data.code == 200) {
            _this.$message({
              message: "删除成功",
              type: "success",
            });
            _this.initData();
          }
        },
      });
    },
    toggleToolsBar() {},
    //每页显示数量
    handleSizeChange(val) {
      if (this.pageSize != val) {
        this.pageSize = val;
        this.initData();
      }
    },
    //跳转到第几页
    handleCurrentChange(val) {
      if (this.pageIndex != val) {
        this.pageIndex = val;
        this.initData();
      }
    },
  },
  created() {},
};
</script>
<style scoped>
.content-box .table-list .nowrap {
  white-space: inherit;
}
.sb_select > .el-input {
  width: 130px;
}
.zt_select > .el-input {
  width: 130px;
}
</style>




// WEBPACK FOOTER //
// src/components/VirtualPowerPlant/Invitation/Invitation.vue